export class DeleteDateRangeModel {
 
  public beginYear: number;
  public beginMonth: number;
  public beginDay: number;

  public endYear: number;
  public endMonth: number;
  public endDay: number;

  public wellId: number;
}
